// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"videoblock_imageBlock__vhxDM","imageButton":"videoblock_imageButton__XRThC","image":"videoblock_image__B7rzW"};